// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-header {
    width: 100%;
    max-height: 66px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 25px 0px 0px;
    background-color: rgb(63, 63, 63);
    color: rgb(197, 197, 197);
    border-bottom: 1px solid rgb(95, 95, 95);
}

.dashboard-profile {
    display: grid;
    grid-template-columns: 1fr min-content;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 19px;
    padding: 10px;
}

.flex {
    display: flex;
    align-items: center;
}

.profileImage {
    width: 80px;
}

.clock {
    color: rgb(197, 197, 197);
    margin: 0;
}

.dashboard-name {
    font-size: 14px;
    cursor: pointer;
    margin: 0;
}

.dashboard-header>.dashboard-profile .content-img {
    margin: 0;
    width: 50px;
    height: 50px;
    border-width: 2.5px;
    border-radius: 50%;
    object-fit: cover;
    margin-left: auto;
}

.dashboard-logo {
    height: 56px;
    text-align: left;
    margin-right: 30px;
    object-fit: contain;
    object-position: 0;
    position: relative;
}

.sidebar {
    transition: width .35s cubic-bezier(0.4, 0, 0.2, 1);
    width: 65px;
}

.collapsed {
    width: 65px;
    height: calc(100vh - 88px);

    transition: width .3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    position: fixed;

    min-height: calc(100vh - 66px);
    border-right: 1px solid rgba(255, 255, 255, 0.06);
    background: linear-gradient(180deg, rgb(58, 58, 58) 0%, rgb(48, 48, 48) 45%, rgb(42, 42, 42) 100%);
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.25);
}

.divider {
    padding: 0 0 0 20px;
}

.platform-view {
    padding: 0 20px;
    display: inline-block;
    border-right: 1px solid;
    padding-right: 10px;
    margin-right: 10px;
}

.collapsed .hiddenCollapsed {
    opacity: 0;
    width: 0;
    visibility: hidden;
    transition: all .25s ease-in-out;
}

.sidebar:hover,
.sidebar:hover>.collapsed,
.sidebar.expand,
.collapsed.expand {
    min-width: 231px;
    width: auto;
}

.navOverlay {
    display: flex;
    z-index: 103;
    position: relative;
}

.navOverlay.expand {
    display: flex;
}

.collapsed nav {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.sidebar__heading {
    margin: 0;
    padding: 18px 14px 12px;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.45);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sidebar__list {
    list-style: none;
    margin: 0;
    padding: 0px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    overflow-y: auto;
    padding-bottom: 60px;
}

.sidebar__item {
    margin: 0;
    padding: 0;
}

.sidebar__group-label {
    margin: 10px 0 2px;
    padding: 0 10px;
    list-style: none;
}

.sidebar__group-label:first-child {
    margin-top: 4px;
}

.sidebar__group-label-text {
    display: block;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.28);
    padding: 4px 2px 2px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sidebar__group-label:first-child .sidebar__group-label-text {
    border-top: none;
}

.collapsed .navItems,
.collapsed .sidebar__link {
    color: rgba(255, 255, 255, 0.88);
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 12px 10px;
    overflow: hidden;
    align-items: center;
    justify-content: flex-start;
    white-space: nowrap;
    transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    text-decoration: none;
    box-sizing: border-box;
}

.navItems.--active,
.sidebar__link.--active {
    background: rgba(255, 255, 255, 0.08);
    color: rgb(255, 255, 255);
    box-shadow: inset 3px 0 0 0 rgb(192, 159, 83);
}

.sidebar__link--indent {
    padding-left: 30px !important;
    font-size: 0.86rem;
    color: rgba(255, 255, 255, 0.6);
}

.sidebar__link--indent.--active {
    color: rgb(255, 255, 255);
}

.navItems:hover:not(.--active),
.sidebar__link:hover:not(.--active) {
    background-color: rgba(255, 255, 255, 0.06);
    color: rgb(255, 255, 255);
}

.collapsed:hover .navItems,
.collapsed:hover .sidebar__link,
.collapsed.expand a.navItems,
.collapsed.expand a.sidebar__link {
    width: 100%;
}

.collapsed:hover nav,
.collapsed.expand nav {
    width: 150px;
}

.collapsed.expand .hiddenCollapsed,
.collapsed:hover .hiddenCollapsed {
    opacity: 1;
    width: auto;
    visibility: visible;
}

.dashboard-icons {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    background-position: center;
}

.dashboard-icons:after{

}

.dashboard-icons::after {
    content: "";
    font-style: normal;
    font-size: 20px;
    display: block;
    width: 20px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    background-position: center;
}

.secondary{
    background-color: transparent;
    border: 1px solid #fff;
    color: #fff;
    font-size: 14px;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin-left: 10px;
}

/* .dashboard-icons[data-icon]::after {
    content: "";
    background: url();
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    width: 20px;
    height: 20px;
} */

/* .reports::after {
    content: "";
    background: url("icons/reports.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.compare::after {
    content: "";
    background: url("icons/reports.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.home::after {
    content: "";
    background: url("icons/home.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.user-consents::after {
    content: "";
    background: url("icons/user-consents.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.domains::after {
    content: "";
    background: url("icons/domain.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.settings::after {
    content: "";
    background: url("icons/settings.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.cookies {
    content: "";
    background: url("icons/cookies.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.logout::after {
    content: "";
    background: url("icons/Logout.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    display: block;
    font-style: normal;
    font-size: 20px;
    width: 20px;
    height: 20px;
} */

.expandBtn {
    float: right;
    padding: 10px;
    margin: 10px 0px;
    border: none;
    background: transparent;
    color: #fff;

    display: flex;
    align-items: center;
    justify-content: end;
    cursor: pointer;
}

.navItems--bottom {
    margin-top: auto;
}

.navLogout {
    margin-top: auto;
    background: transparent;
    border: none;
    width: 100%;
    color: #fff;
    padding: 30px 15px;
    font-size: 15px;
    text-align: center;
    border-top: 1px solid #636363;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

}

.dashboard-organisationSelector {
    border: none;
    padding: 0px 17px;
    background: transparent;
    color: #fff;
    font-size: 12px;
    appearance: none;
    -webkit-appearance: none;
    position: relative;
}

.dashboard-organisationSelector:focus,
.dashboard-organisationSelector:focus-within,
.dashboard-organisationSelector:focus-visible {
    outline: none;
}

.dashboard-organisationContainer {
    position: relative;
}

.dashboard-profile__nameContainer {
    width: 250px;
    margin-right: 20px;
    text-align: right;
}

.arrowRight {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-left: 10px;

}

.company_container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.company_container .selectorContianer,
.company_container .selector-container {
    margin-right: 16px;
    min-width: 0;
}

.company_container .selectorContianer:last-child,
.company_container .selector-container:last-child {
    margin-right: 0;
}

.selector.selector--placeholder {
    min-height: 36px;
    min-width: 120px;
    visibility: hidden;
    pointer-events: none;
}

.logo_container {
    display: flex;
    align-items: center
}

.logo-selector-container {
    display: flex;
    align-items: center;
}

.menu {
    display: none;
}

.dashboard-content h1{
    display: flex;
}

.sticky-title {
    font-size: 1.5em;
}

@media screen and (min-width: 320px) and (max-width: 900px) {
    .dashboard-header {
        width: 100%;
        max-height: none;
        padding: 0 8px 0 4px;
    }

    .main-grid {
        padding-top: 121px;
    }

    .menu {
        display: block;
        padding: 8px 10px;
        margin-right: 2px;
        cursor: pointer;
        background-color: transparent;
        border: none;
        color: #fff;
        border-radius: 8px;
        transition: background-color 0.2s ease;
    }

    .menu:focus-visible {
        outline: 2px solid rgba(192, 159, 83, 0.6);
        outline-offset: 2px;
    }

    .menu:active {
        background-color: rgba(255, 255, 255, 0.06);
    }

    .menu-bar {
        width: 22px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.92);
        margin: 5px auto;
        transition: all 0.3s ease-in-out;
        border-radius: 2px;
    }

    .dashboard-profile {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-rows: auto auto;
        align-items: start;
        gap: 10px 10px;
        padding: 8px 4px 10px 8px;
        width: 100%;
    }

    .logo-selector-container {
        display: contents;
    }

    .logo_container {
        grid-column: 1;
        grid-row: 1;
        display: flex;
        align-items: center;
        gap: 2px;
        min-width: 0;
    }

    .company_container {
        grid-column: 1 / -1;
        grid-row: 2;
        display: grid;
        grid-template-columns: 1fr;
        gap: 8px;
        width: 100%;
        max-width: 100%;
        padding-bottom: 0;
        padding-right: 0;
        align-items: stretch;
        justify-content: stretch;
    }

    .company_container .selectorContianer,
    .company_container .selector-container,
    .company_container .property-selector {
        margin-right: 0;
        width: 100%;
        min-width: 0;
    }

    .dashboard-profile > .flex.profileImage {
        grid-column: 2;
        grid-row: 1;
        justify-self: end;
        align-self: start;
    }

    .dashboard-logo {
        height: 44px;
        margin-right: 0;
        max-width: min(200px, calc(100vw - 120px));
    }

    .grid-3 {
        grid-template-columns: 1fr;
    }

    .grid-container {
        display: block;
    }

    .dashboard-profile__nameContainer {
        width: auto;
    }

    .navOverlay {
        display: none;
    }

    .sidebar .collapsed{
        width: 300px;
        min-height: calc(100vh - 200px);
    }

    .sidebar:hover,
    .sidebar:hover>.collapsed,
    .sidebar.expand,
    .collapsed.expand{
        width: 300px;
    }

    .collapsed .hiddenCollapsed{
        opacity: 1;
        width: auto;
        visibility: visible;
    }

    .dashboard-header > .dashboard-profile .content-img {
        margin: 0;
    }

    .platform-view {
        border: none;
        padding: 0;
        margin: 0;
    }

    .infoHeader {
        position: relative;
    }

    .infoHeader.sticky {
        top: 121px;
    }

    .infoHeader .dashboard-content {
        grid-template-columns: .5fr 1fr !important;
    }

    .infoHeader .crawl-cta {
        width: max-content;
    }

    .sticky-title{
        font-size: 1em;
        display: block !important;
    }
}

@media screen and (min-width: 320px) and (max-width: 480px) {
    .company_container {
        grid-template-columns: 1fr;
    }
}

/* SideNav (reports/settings): mobile drawer + toggle */
.sidebar__top {
    display: contents;
}

.sidebar-mobile-toggle {
    display: none;
}

.sidebar-backdrop {
    display: none;
}

@media (max-width: 768px) {
    .sidebar-mobile-toggle {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        position: fixed;
        top: 120px;
        left: 12px;
        z-index: 102;
        padding: 8px 12px;
        margin: 0;
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 8px;
        background: linear-gradient(180deg, rgb(58, 58, 58) 0%, rgb(48, 48, 48) 100%);
        color: rgba(255, 255, 255, 0.92);
        font: inherit;
        font-size: 14px;
        cursor: pointer;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
    }

    .sidebar-mobile-toggle__bars {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .sidebar-mobile-toggle__bar {
        display: block;
        width: 18px;
        height: 2px;
        background: currentColor;
        border-radius: 1px;
    }

    .sidebar-mobile-toggle__label {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }

    .sidebar-backdrop {
        display: block;
        position: fixed;
        inset: 0;
        z-index: 100;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity 0.25s ease, visibility 0.25s ease;
    }

    .sidebar-backdrop.sidebar-backdrop--visible {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }

    .sidebar.expand {
        width: 0 !important;
        min-width: 0 !important;
        overflow: visible;
    }

    .sidebar.expand .collapsed {
        transform: translateX(-100%);
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        width: min(86vw, 300px) !important;
        min-width: min(86vw, 300px) !important;
        top: 66px;
        height: calc(100vh - 66px) !important;
        min-height: calc(100vh - 66px) !important;
        z-index: 102;
        box-shadow: 6px 0 28px rgba(0, 0, 0, 0.35);
    }

    .sidebar.expand.sidebar--open .collapsed {
        transform: translateX(0);
    }

    .sidebar.expand .collapsed:hover,
    .sidebar.expand.sidebar--open .collapsed {
        min-width: min(86vw, 300px) !important;
        width: min(86vw, 300px) !important;
    }

    .sidebar.expand .collapsed:hover nav,
    .sidebar.expand.sidebar--open .collapsed nav {
        width: 100%;
    }

    .sidebar__top {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        gap: 8px;
        padding-right: 4px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        margin-bottom: 4px;
    }

    .sidebar__top .sidebar__heading {
        border-bottom: none;
        padding-bottom: 8px;
        flex: 1;
        min-width: 0;
    }

    .sidebar-mobile-close {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        margin: 0;
        padding: 0;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: rgba(255, 255, 255, 0.88);
        font-size: 28px;
        line-height: 1;
        cursor: pointer;
    }

    .sidebar-mobile-close:hover {
        background: rgba(255, 255, 255, 0.08);
    }

    /* Shift the sticky page title clear of the fixed sidebar toggle */
    .infoHeader .dashboard-content {
        padding-left: 56px;
    }
}

@media (min-width: 769px) {
    .sidebar-mobile-close {
        display: none !important;
    }
}

/* ── Notification Center ─────────────────────────────────────────────────── */
.notif-center {
    position: relative;
    display: flex;
    align-items: center;
}

.notif-bell {
    position: relative;
    background: none;
    border: none;
    cursor: pointer;
    color: rgb(197, 197, 197);
    padding: 6px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;
}
.notif-bell:hover {
    background: rgba(255,255,255,0.08);
    color: #fff;
}

.notif-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    background: #e05252;
    color: #fff;
    font-size: 0.6rem;
    font-weight: 700;
    min-width: 16px;
    height: 16px;
    border-radius: 8px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    pointer-events: none;
}

.notif-dropdown {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    width: 340px;
    background: #2a2a2a;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.5);
    z-index: 200;
    overflow: hidden;
}

.notif-dropdown__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 10px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
}

.notif-dropdown__title {
    font-size: 0.85rem;
    font-weight: 600;
    color: rgba(220,225,235,0.95);
}

.notif-dropdown__mark-all {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.75rem;
    color: rgba(140,160,255,0.85);
    padding: 0;
}
.notif-dropdown__mark-all:hover { color: rgba(140,160,255,1); }

.notif-dropdown__list {
    max-height: 400px;
    overflow-y: auto;
}

.notif-dropdown__empty {
    padding: 24px 16px;
    text-align: center;
    font-size: 0.82rem;
    color: rgba(180,185,200,0.5);
    margin: 0;
}

.notif-item {
    position: relative;
    padding: 12px 16px 12px 28px;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    cursor: default;
    transition: background 0.12s;
}
.notif-item:last-child { border-bottom: none; }
.notif-item--unread { cursor: pointer; background: rgba(140,160,255,0.05); }
.notif-item--unread:hover { background: rgba(140,160,255,0.1); }

.notif-item__dot {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #8ca0ff;
}

.notif-item__body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 4px;
}

.notif-item__title {
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(220,225,235,0.9);
}

.notif-item__msg {
    font-size: 0.78rem;
    color: rgba(180,185,200,0.75);
    line-height: 1.4;
}

.notif-item__meta {
    display: flex;
    align-items: center;
    gap: 8px;
}

.notif-item__domain {
    font-size: 0.7rem;
    color: rgba(140,160,255,0.7);
}

.notif-item__time {
    font-size: 0.7rem;
    color: rgba(180,185,200,0.4);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/header.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,iCAAiC;IACjC,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,SAAS;AACb;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0BAA0B;;IAE1B,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,eAAe;;IAEf,8BAA8B;IAC9B,iDAAiD;IACjD,kGAAkG;IAClG,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;;;;IAII,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,kDAAkD;IAClD,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;IACP,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gCAAgC;IAChC,oBAAoB;IACpB,+CAA+C;IAC/C,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gCAAgC;IAChC,aAAa;IACb,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,6EAA6E;IAC7E,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,qCAAqC;IACrC,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;;;;IAII,WAAW;AACf;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;AACrB;;AAEA;;;;;;;;;GASG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAsGG;;AAEH;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,WAAW;;IAEX,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;QACjB,eAAe;QACf,6BAA6B;QAC7B,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,sCAAsC;IAC1C;;IAEA;QACI,0CAA0C;QAC1C,mBAAmB;IACvB;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,WAAW;QACX,WAAW;QACX,2CAA2C;QAC3C,gBAAgB;QAChB,gCAAgC;QAChC,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,+BAA+B;QAC/B,6BAA6B;QAC7B,kBAAkB;QAClB,cAAc;QACd,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,aAAa;QACb,0BAA0B;QAC1B,QAAQ;QACR,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;QACpB,wBAAwB;IAC5B;;IAEA;;;QAGI,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,0CAA0C;IAC9C;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,+BAA+B;IACnC;;IAEA;;;;QAII,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,uDAAuD;AACvD;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;QACT,eAAe;QACf,UAAU;QACV,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,SAAS;QACT,2CAA2C;QAC3C,kBAAkB;QAClB,6EAA6E;QAC7E,gCAAgC;QAChC,aAAa;QACb,eAAe;QACf,eAAe;QACf,0CAA0C;IAC9C;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,WAAW;QACX,WAAW;QACX,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,eAAe;QACf,QAAQ;QACR,YAAY;QACZ,8BAA8B;QAC9B,UAAU;QACV,kBAAkB;QAClB,oBAAoB;QACpB,qDAAqD;IACzD;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;QAC5B,uDAAuD;QACvD,kCAAkC;QAClC,sCAAsC;QACtC,SAAS;QACT,qCAAqC;QACrC,yCAAyC;QACzC,YAAY;QACZ,0CAA0C;IAC9C;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,sCAAsC;QACtC,kCAAkC;IACtC;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,8BAA8B;QAC9B,QAAQ;QACR,kBAAkB;QAClB,kDAAkD;QAClD,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,OAAO;QACP,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,cAAc;QACd,WAAW;QACX,YAAY;QACZ,SAAS;QACT,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,gCAAgC;QAChC,eAAe;QACf,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA,kEAAkE;IAClE;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;AACA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,UAAU;AACd;AACA,kCAAkC,0BAA0B,EAAE;;AAE9D;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,+CAA+C;IAC/C,eAAe;IACf,4BAA4B;AAChC;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,sBAAsB,eAAe,EAAE,kCAAkC,EAAE;AAC3E,4BAA4B,iCAAiC,EAAE;;AAE/D;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;AAChC","sourcesContent":[".dashboard-header {\n    width: 100%;\n    max-height: 66px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 101;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 25px 0px 0px;\n    background-color: rgb(63, 63, 63);\n    color: rgb(197, 197, 197);\n    border-bottom: 1px solid rgb(95, 95, 95);\n}\n\n.dashboard-profile {\n    display: grid;\n    grid-template-columns: 1fr min-content;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    font-size: 19px;\n    padding: 10px;\n}\n\n.flex {\n    display: flex;\n    align-items: center;\n}\n\n.profileImage {\n    width: 80px;\n}\n\n.clock {\n    color: rgb(197, 197, 197);\n    margin: 0;\n}\n\n.dashboard-name {\n    font-size: 14px;\n    cursor: pointer;\n    margin: 0;\n}\n\n.dashboard-header>.dashboard-profile .content-img {\n    margin: 0;\n    width: 50px;\n    height: 50px;\n    border-width: 2.5px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-left: auto;\n}\n\n.dashboard-logo {\n    height: 56px;\n    text-align: left;\n    margin-right: 30px;\n    object-fit: contain;\n    object-position: 0;\n    position: relative;\n}\n\n.sidebar {\n    transition: width .35s cubic-bezier(0.4, 0, 0.2, 1);\n    width: 65px;\n}\n\n.collapsed {\n    width: 65px;\n    height: calc(100vh - 88px);\n\n    transition: width .3s cubic-bezier(0.4, 0, 0.2, 1);\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n\n    min-height: calc(100vh - 66px);\n    border-right: 1px solid rgba(255, 255, 255, 0.06);\n    background: linear-gradient(180deg, rgb(58, 58, 58) 0%, rgb(48, 48, 48) 45%, rgb(42, 42, 42) 100%);\n    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.25);\n}\n\n.divider {\n    padding: 0 0 0 20px;\n}\n\n.platform-view {\n    padding: 0 20px;\n    display: inline-block;\n    border-right: 1px solid;\n    padding-right: 10px;\n    margin-right: 10px;\n}\n\n.collapsed .hiddenCollapsed {\n    opacity: 0;\n    width: 0;\n    visibility: hidden;\n    transition: all .25s ease-in-out;\n}\n\n.sidebar:hover,\n.sidebar:hover>.collapsed,\n.sidebar.expand,\n.collapsed.expand {\n    min-width: 231px;\n    width: auto;\n}\n\n.navOverlay {\n    display: flex;\n    z-index: 103;\n    position: relative;\n}\n\n.navOverlay.expand {\n    display: flex;\n}\n\n.collapsed nav {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n}\n\n.sidebar__heading {\n    margin: 0;\n    padding: 18px 14px 12px;\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.45);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sidebar__list {\n    list-style: none;\n    margin: 0;\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n    overflow-y: auto;\n    padding-bottom: 60px;\n}\n\n.sidebar__item {\n    margin: 0;\n    padding: 0;\n}\n\n.sidebar__group-label {\n    margin: 10px 0 2px;\n    padding: 0 10px;\n    list-style: none;\n}\n\n.sidebar__group-label:first-child {\n    margin-top: 4px;\n}\n\n.sidebar__group-label-text {\n    display: block;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.28);\n    padding: 4px 2px 2px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sidebar__group-label:first-child .sidebar__group-label-text {\n    border-top: none;\n}\n\n.collapsed .navItems,\n.collapsed .sidebar__link {\n    color: rgba(255, 255, 255, 0.88);\n    display: flex;\n    gap: 10px;\n    width: 100%;\n    padding: 12px 10px;\n    overflow: hidden;\n    align-items: center;\n    justify-content: flex-start;\n    white-space: nowrap;\n    transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n    text-decoration: none;\n    box-sizing: border-box;\n}\n\n.navItems.--active,\n.sidebar__link.--active {\n    background: rgba(255, 255, 255, 0.08);\n    color: rgb(255, 255, 255);\n    box-shadow: inset 3px 0 0 0 rgb(192, 159, 83);\n}\n\n.sidebar__link--indent {\n    padding-left: 30px !important;\n    font-size: 0.86rem;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.sidebar__link--indent.--active {\n    color: rgb(255, 255, 255);\n}\n\n.navItems:hover:not(.--active),\n.sidebar__link:hover:not(.--active) {\n    background-color: rgba(255, 255, 255, 0.06);\n    color: rgb(255, 255, 255);\n}\n\n.collapsed:hover .navItems,\n.collapsed:hover .sidebar__link,\n.collapsed.expand a.navItems,\n.collapsed.expand a.sidebar__link {\n    width: 100%;\n}\n\n.collapsed:hover nav,\n.collapsed.expand nav {\n    width: 150px;\n}\n\n.collapsed.expand .hiddenCollapsed,\n.collapsed:hover .hiddenCollapsed {\n    opacity: 1;\n    width: auto;\n    visibility: visible;\n}\n\n.dashboard-icons {\n    width: 25px;\n    height: 25px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    background-position: center;\n}\n\n.dashboard-icons:after{\n\n}\n\n.dashboard-icons::after {\n    content: \"\";\n    font-style: normal;\n    font-size: 20px;\n    display: block;\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    background-position: center;\n}\n\n.secondary{\n    background-color: transparent;\n    border: 1px solid #fff;\n    color: #fff;\n    font-size: 14px;\n    width: 30px;\n    height: 30px;\n    border-radius: 5px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin-left: 10px;\n}\n\n/* .dashboard-icons[data-icon]::after {\n    content: \"\";\n    background: url();\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    width: 20px;\n    height: 20px;\n} */\n\n/* .reports::after {\n    content: \"\";\n    background: url(\"icons/reports.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.compare::after {\n    content: \"\";\n    background: url(\"icons/reports.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.home::after {\n    content: \"\";\n    background: url(\"icons/home.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.user-consents::after {\n    content: \"\";\n    background: url(\"icons/user-consents.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.domains::after {\n    content: \"\";\n    background: url(\"icons/domain.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.settings::after {\n    content: \"\";\n    background: url(\"icons/settings.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.cookies {\n    content: \"\";\n    background: url(\"icons/cookies.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.logout::after {\n    content: \"\";\n    background: url(\"icons/Logout.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-blend-mode: lighten;\n    display: block;\n    font-style: normal;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n} */\n\n.expandBtn {\n    float: right;\n    padding: 10px;\n    margin: 10px 0px;\n    border: none;\n    background: transparent;\n    color: #fff;\n\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    cursor: pointer;\n}\n\n.navItems--bottom {\n    margin-top: auto;\n}\n\n.navLogout {\n    margin-top: auto;\n    background: transparent;\n    border: none;\n    width: 100%;\n    color: #fff;\n    padding: 30px 15px;\n    font-size: 15px;\n    text-align: center;\n    border-top: 1px solid #636363;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.dashboard-organisationSelector {\n    border: none;\n    padding: 0px 17px;\n    background: transparent;\n    color: #fff;\n    font-size: 12px;\n    appearance: none;\n    -webkit-appearance: none;\n    position: relative;\n}\n\n.dashboard-organisationSelector:focus,\n.dashboard-organisationSelector:focus-within,\n.dashboard-organisationSelector:focus-visible {\n    outline: none;\n}\n\n.dashboard-organisationContainer {\n    position: relative;\n}\n\n.dashboard-profile__nameContainer {\n    width: 250px;\n    margin-right: 20px;\n    text-align: right;\n}\n\n.arrowRight {\n    width: 10px;\n    height: 10px;\n    display: inline-block;\n    margin-left: 10px;\n\n}\n\n.company_container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.company_container .selectorContianer,\n.company_container .selector-container {\n    margin-right: 16px;\n    min-width: 0;\n}\n\n.company_container .selectorContianer:last-child,\n.company_container .selector-container:last-child {\n    margin-right: 0;\n}\n\n.selector.selector--placeholder {\n    min-height: 36px;\n    min-width: 120px;\n    visibility: hidden;\n    pointer-events: none;\n}\n\n.logo_container {\n    display: flex;\n    align-items: center\n}\n\n.logo-selector-container {\n    display: flex;\n    align-items: center;\n}\n\n.menu {\n    display: none;\n}\n\n.dashboard-content h1{\n    display: flex;\n}\n\n.sticky-title {\n    font-size: 1.5em;\n}\n\n@media screen and (min-width: 320px) and (max-width: 900px) {\n    .dashboard-header {\n        width: 100%;\n        max-height: none;\n        padding: 0 8px 0 4px;\n    }\n\n    .main-grid {\n        padding-top: 121px;\n    }\n\n    .menu {\n        display: block;\n        padding: 8px 10px;\n        margin-right: 2px;\n        cursor: pointer;\n        background-color: transparent;\n        border: none;\n        color: #fff;\n        border-radius: 8px;\n        transition: background-color 0.2s ease;\n    }\n\n    .menu:focus-visible {\n        outline: 2px solid rgba(192, 159, 83, 0.6);\n        outline-offset: 2px;\n    }\n\n    .menu:active {\n        background-color: rgba(255, 255, 255, 0.06);\n    }\n\n    .menu-bar {\n        width: 22px;\n        height: 2px;\n        background-color: rgba(255, 255, 255, 0.92);\n        margin: 5px auto;\n        transition: all 0.3s ease-in-out;\n        border-radius: 2px;\n    }\n\n    .dashboard-profile {\n        display: grid;\n        grid-template-columns: 1fr auto;\n        grid-template-rows: auto auto;\n        align-items: start;\n        gap: 10px 10px;\n        padding: 8px 4px 10px 8px;\n        width: 100%;\n    }\n\n    .logo-selector-container {\n        display: contents;\n    }\n\n    .logo_container {\n        grid-column: 1;\n        grid-row: 1;\n        display: flex;\n        align-items: center;\n        gap: 2px;\n        min-width: 0;\n    }\n\n    .company_container {\n        grid-column: 1 / -1;\n        grid-row: 2;\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 8px;\n        width: 100%;\n        max-width: 100%;\n        padding-bottom: 0;\n        padding-right: 0;\n        align-items: stretch;\n        justify-content: stretch;\n    }\n\n    .company_container .selectorContianer,\n    .company_container .selector-container,\n    .company_container .property-selector {\n        margin-right: 0;\n        width: 100%;\n        min-width: 0;\n    }\n\n    .dashboard-profile > .flex.profileImage {\n        grid-column: 2;\n        grid-row: 1;\n        justify-self: end;\n        align-self: start;\n    }\n\n    .dashboard-logo {\n        height: 44px;\n        margin-right: 0;\n        max-width: min(200px, calc(100vw - 120px));\n    }\n\n    .grid-3 {\n        grid-template-columns: 1fr;\n    }\n\n    .grid-container {\n        display: block;\n    }\n\n    .dashboard-profile__nameContainer {\n        width: auto;\n    }\n\n    .navOverlay {\n        display: none;\n    }\n\n    .sidebar .collapsed{\n        width: 300px;\n        min-height: calc(100vh - 200px);\n    }\n\n    .sidebar:hover,\n    .sidebar:hover>.collapsed,\n    .sidebar.expand,\n    .collapsed.expand{\n        width: 300px;\n    }\n\n    .collapsed .hiddenCollapsed{\n        opacity: 1;\n        width: auto;\n        visibility: visible;\n    }\n\n    .dashboard-header > .dashboard-profile .content-img {\n        margin: 0;\n    }\n\n    .platform-view {\n        border: none;\n        padding: 0;\n        margin: 0;\n    }\n\n    .infoHeader {\n        position: relative;\n    }\n\n    .infoHeader.sticky {\n        top: 121px;\n    }\n\n    .infoHeader .dashboard-content {\n        grid-template-columns: .5fr 1fr !important;\n    }\n\n    .infoHeader .crawl-cta {\n        width: max-content;\n    }\n\n    .sticky-title{\n        font-size: 1em;\n        display: block !important;\n    }\n}\n\n@media screen and (min-width: 320px) and (max-width: 480px) {\n    .company_container {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* SideNav (reports/settings): mobile drawer + toggle */\n.sidebar__top {\n    display: contents;\n}\n\n.sidebar-mobile-toggle {\n    display: none;\n}\n\n.sidebar-backdrop {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .sidebar-mobile-toggle {\n        display: inline-flex;\n        align-items: center;\n        gap: 10px;\n        position: fixed;\n        top: 120px;\n        left: 12px;\n        z-index: 102;\n        padding: 8px 12px;\n        margin: 0;\n        border: 1px solid rgba(255, 255, 255, 0.12);\n        border-radius: 8px;\n        background: linear-gradient(180deg, rgb(58, 58, 58) 0%, rgb(48, 48, 48) 100%);\n        color: rgba(255, 255, 255, 0.92);\n        font: inherit;\n        font-size: 14px;\n        cursor: pointer;\n        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);\n    }\n\n    .sidebar-mobile-toggle__bars {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    }\n\n    .sidebar-mobile-toggle__bar {\n        display: block;\n        width: 18px;\n        height: 2px;\n        background: currentColor;\n        border-radius: 1px;\n    }\n\n    .sidebar-mobile-toggle__label {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        padding: 0;\n        margin: -1px;\n        overflow: hidden;\n        clip: rect(0, 0, 0, 0);\n        border: 0;\n    }\n\n    .sidebar-backdrop {\n        display: block;\n        position: fixed;\n        inset: 0;\n        z-index: 100;\n        background: rgba(0, 0, 0, 0.5);\n        opacity: 0;\n        visibility: hidden;\n        pointer-events: none;\n        transition: opacity 0.25s ease, visibility 0.25s ease;\n    }\n\n    .sidebar-backdrop.sidebar-backdrop--visible {\n        opacity: 1;\n        visibility: visible;\n        pointer-events: auto;\n    }\n\n    .sidebar.expand {\n        width: 0 !important;\n        min-width: 0 !important;\n        overflow: visible;\n    }\n\n    .sidebar.expand .collapsed {\n        transform: translateX(-100%);\n        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        width: min(86vw, 300px) !important;\n        min-width: min(86vw, 300px) !important;\n        top: 66px;\n        height: calc(100vh - 66px) !important;\n        min-height: calc(100vh - 66px) !important;\n        z-index: 102;\n        box-shadow: 6px 0 28px rgba(0, 0, 0, 0.35);\n    }\n\n    .sidebar.expand.sidebar--open .collapsed {\n        transform: translateX(0);\n    }\n\n    .sidebar.expand .collapsed:hover,\n    .sidebar.expand.sidebar--open .collapsed {\n        min-width: min(86vw, 300px) !important;\n        width: min(86vw, 300px) !important;\n    }\n\n    .sidebar.expand .collapsed:hover nav,\n    .sidebar.expand.sidebar--open .collapsed nav {\n        width: 100%;\n    }\n\n    .sidebar__top {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        justify-content: space-between;\n        gap: 8px;\n        padding-right: 4px;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n        margin-bottom: 4px;\n    }\n\n    .sidebar__top .sidebar__heading {\n        border-bottom: none;\n        padding-bottom: 8px;\n        flex: 1;\n        min-width: 0;\n    }\n\n    .sidebar-mobile-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        width: 40px;\n        height: 40px;\n        margin: 0;\n        padding: 0;\n        border: none;\n        border-radius: 8px;\n        background: transparent;\n        color: rgba(255, 255, 255, 0.88);\n        font-size: 28px;\n        line-height: 1;\n        cursor: pointer;\n    }\n\n    .sidebar-mobile-close:hover {\n        background: rgba(255, 255, 255, 0.08);\n    }\n\n    /* Shift the sticky page title clear of the fixed sidebar toggle */\n    .infoHeader .dashboard-content {\n        padding-left: 56px;\n    }\n}\n\n@media (min-width: 769px) {\n    .sidebar-mobile-close {\n        display: none !important;\n    }\n}\n\n/* ── Notification Center ─────────────────────────────────────────────────── */\n.notif-center {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.notif-bell {\n    position: relative;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: rgb(197, 197, 197);\n    padding: 6px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s, color 0.15s;\n}\n.notif-bell:hover {\n    background: rgba(255,255,255,0.08);\n    color: #fff;\n}\n\n.notif-badge {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    background: #e05252;\n    color: #fff;\n    font-size: 0.6rem;\n    font-weight: 700;\n    min-width: 16px;\n    height: 16px;\n    border-radius: 8px;\n    padding: 0 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n    pointer-events: none;\n}\n\n.notif-dropdown {\n    position: absolute;\n    top: calc(100% + 10px);\n    right: 0;\n    width: 340px;\n    background: #2a2a2a;\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 10px;\n    box-shadow: 0 8px 32px rgba(0,0,0,0.5);\n    z-index: 200;\n    overflow: hidden;\n}\n\n.notif-dropdown__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 16px 10px;\n    border-bottom: 1px solid rgba(255,255,255,0.07);\n}\n\n.notif-dropdown__title {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: rgba(220,225,235,0.95);\n}\n\n.notif-dropdown__mark-all {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 0.75rem;\n    color: rgba(140,160,255,0.85);\n    padding: 0;\n}\n.notif-dropdown__mark-all:hover { color: rgba(140,160,255,1); }\n\n.notif-dropdown__list {\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.notif-dropdown__empty {\n    padding: 24px 16px;\n    text-align: center;\n    font-size: 0.82rem;\n    color: rgba(180,185,200,0.5);\n    margin: 0;\n}\n\n.notif-item {\n    position: relative;\n    padding: 12px 16px 12px 28px;\n    border-bottom: 1px solid rgba(255,255,255,0.05);\n    cursor: default;\n    transition: background 0.12s;\n}\n.notif-item:last-child { border-bottom: none; }\n.notif-item--unread { cursor: pointer; background: rgba(140,160,255,0.05); }\n.notif-item--unread:hover { background: rgba(140,160,255,0.1); }\n\n.notif-item__dot {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #8ca0ff;\n}\n\n.notif-item__body {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    margin-bottom: 4px;\n}\n\n.notif-item__title {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(220,225,235,0.9);\n}\n\n.notif-item__msg {\n    font-size: 0.78rem;\n    color: rgba(180,185,200,0.75);\n    line-height: 1.4;\n}\n\n.notif-item__meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.notif-item__domain {\n    font-size: 0.7rem;\n    color: rgba(140,160,255,0.7);\n}\n\n.notif-item__time {\n    font-size: 0.7rem;\n    color: rgba(180,185,200,0.4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
